


































export default

	props:
		card: Object

		imageStyle:
			type: String
			default: 'cover'

		noHover:
			type: Boolean
			default: false

		keepButton:
			type: Boolean
			default: false

	computed:
		classes: -> [
			'no-hover' if @noHover
			'hover' if !@noHover
			'keep-button' if @keepButton
		]

		objectFit: -> @imageStyle

